import { render, staticRenderFns } from "./ModalFuncionalidades.vue?vue&type=template&id=57034227&"
import script from "./ModalFuncionalidades.vue?vue&type=script&lang=js&"
export * from "./ModalFuncionalidades.vue?vue&type=script&lang=js&"
import style0 from "./ModalFuncionalidades.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports